import React from 'react'

import { DatePickerInput } from '@mantine/dates'

import { DefaultDaterangeFilterProps } from '../../hooks/useDebouncedFilterValue/use-debounced-filter-value'
import useDebouncedFilterValue from '../../hooks/useDebouncedFilterValue/useDebouncedFilterValues'
// import i18n from '../../i18n'

const DefaultDateRangeFilter = ({
  sortFilter,
  filterDefinition,
}: DefaultDaterangeFilterProps): React.ReactElement => {
  const { label } = filterDefinition

  const { value, onChange } = useDebouncedFilterValue<
    [Date | null, Date | null]
  >({
    filterDefinition,
    sortFilter,
  })
  return (
    <DatePickerInput
      type="range"
      locale={i18n.language}
      label={label}
      clearable
      value={value}
      onChange={onChange}
    />
  )
}

export default DefaultDateRangeFilter
